import React, { useEffect } from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";

// ✅ Sidebar & Protection
import Sidebar from "./components/Sidebar.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";

// ✅ User Pages
import Dashboard from "./pages/Dashboard.jsx";
import AddFundsPage from "./pages/AddFundsPage.jsx";
import SupportPage from "./pages/SupportPage.jsx";
import OrdersPage from "./pages/OrdersPage.jsx";
import PaymentPage from "./pages/PaymentPage.jsx";
import AccountPage from "./pages/AccountPage.jsx";
import TermsPage from "./pages/TermsPage.jsx";
import Login from "./pages/Login.jsx";
import Register from "./pages/Register.jsx";
import AccountSuspended from "./pages/AccountSuspended.jsx";
import Refer from "./pages/Refer.jsx";

// ✅ Admin Pages
import AdminPanel from "./pages/Admin/AdminPanel.jsx";
import OrdersAdmin from "./pages/Admin/OrdersAdmin.jsx";
import FundsAdmin from "./pages/Admin/FundsAdmin.jsx";
import ReportsAdmin from "./pages/Admin/ReportsAdmin.jsx";
import UserListAdmin from "./pages/Admin/UserListAdmin.jsx";
import SettingsAdmin from "./pages/Admin/SettingsAdmin.jsx";
import AdminLogin from "./pages/Admin/AdminLogin.jsx";
import OrdersAdminNew from "./pages/Admin/OrdersAdminNew.jsx";
import TotalFunds from "./pages/Admin/TotalFunds.jsx";
import RevenueDetails from "./pages/Admin/RevenueDetails.jsx";
import AddService from "./pages/Admin/AddService.jsx";
import AdminAccountPage from "./pages/Admin/AdminAccountPage.jsx";

// ✅ Admin Protected Route (NEW)
function AdminProtectedRoute({ children }) {
  const adminToken = localStorage.getItem("adminToken");
  const admin = JSON.parse(localStorage.getItem("admin") || "{}");
  const location = useLocation();

  if (!adminToken || !admin?.email) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}

// ✅ App Layout Wrapper
function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminToken");


  // ✅ Auto Suspend Checker (Final No-Conflict)
useEffect(() => {
  const checkAccountStatus = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/protected", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = res.data?.user;
      if (!user) return;

      // 🚫 যদি suspended হয় — ProtectedRoute-ই হ্যান্ডল করবে
      // এখানে শুধু localStorage আপডেট রাখা দরকার
      localStorage.setItem("user", JSON.stringify(user));
    } catch (err) {
      console.error("🔒 Auth Check Error:", err?.response?.data || err?.message);

      // ❌ Invalid / expired হলে logout করো
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login", { replace: true });
      }
    }
  };

  // ⏳ প্রথমবার কল হবে
  checkAccountStatus();

  // ⏱️ প্রতি 15 সেকেন্ড পর চেক করবে
  const interval = setInterval(checkAccountStatus, 15000);
  return () => clearInterval(interval);
}, [navigate]);
  // ✅ Hide Sidebar on these routes
  const hideSidebar =
    ["/login", "/register", "/account-suspended"].includes(
      location.pathname
    ) || location.pathname.startsWith("/admin");
  return (
    <div className="flex min-h-screen bg-[#0b0f1a] text-white">
      {!hideSidebar && token && <Sidebar />}

      <div className="flex-1 overflow-y-auto">
        <Routes>
          {/* 🔒 USER ROUTES */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/addfunds"
            element={
              <ProtectedRoute>
                <AddFundsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <SupportPage />
              </ProtectedRoute>
            }
          />
          <Route
  path="/refer"
  element={
    <ProtectedRoute>
      <Refer />
    </ProtectedRoute>
  }
/>
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/terms"
            element={
              <ProtectedRoute>
                <TermsPage />
              </ProtectedRoute>
            }
          />

          {/* 🚫 Suspended */}
          <Route path="/account-suspended" element={<AccountSuspended />} />


          {/* 🧩 Auth */}
          <Route
            path="/login"
            element={token ? <Navigate to="/dashboard" replace /> : <Login />}
          />
          <Route
            path="/register"
            element={token ? <Navigate to="/dashboard" replace /> : <Register />}
          />

          {/* 🔐 ADMIN ROUTES */}
          <Route
            path="/admin/login"
            element={adminToken ? <Navigate to="/admin" replace /> : <AdminLogin />}
          />

          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminPanel />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/orders"
            element={
              <AdminProtectedRoute>
                <OrdersAdmin />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/new-orders"
            element={
              <AdminProtectedRoute>
                <OrdersAdminNew />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/funds"
            element={
              <AdminProtectedRoute>
                <FundsAdmin />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/total-funds"
            element={
              <AdminProtectedRoute>
                <TotalFunds />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/revenue-details"
            element={
              <AdminProtectedRoute>
                <RevenueDetails />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <AdminProtectedRoute>
                <ReportsAdmin />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminProtectedRoute>
                <UserListAdmin />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <AdminProtectedRoute>
                <SettingsAdmin />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/new-service"
            element={
              <AdminProtectedRoute>
                <AddService />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/account"
            element={
              <AdminProtectedRoute>
                <AdminAccountPage />
              </AdminProtectedRoute>
            }
          />

          {/* ❌ 404 */}
          <Route
            path="*"
            element={
              <div className="h-screen flex flex-col justify-center items-center bg-[#0b0f1a] text-[#ff6b6b]">
                <h1 className="text-3xl font-bold">404 | Page Not Found</h1>
                <p className="text-gray-400 mt-2">
                  The page you are looking for doesn’t exist.
                </p>
              </div>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}